import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import DimensionMultipleValuePicker from '../DimensionMultipleValuePicker'
import DimensionValuePicker from './DimensionValuePicker'
import useAssignmentsPanel, { Props as AssignmentsPanelProps } from './useAssignmentsPanel'

const SetAssignmentsPanel = (props: AssignmentsPanelProps) => {
  const { onClose, open } = props
  const { assignments, onChangeSingle, onChangeMultiple, onSave, allowSubmit } =
    useAssignmentsPanel(props)

  return (
    <Sidepanel
      overlay={false}
      boxPadding={false}
      width="wide"
      title={i18n.t('finance.employee_dimensions_info.modals.set_assignments.assignment_title', {
        employeeName: props.employeeFullName,
      })}
      onClose={onClose}
      open={open}
      headerBorder
      closeLabel={i18n.t('common.close')}
      locked
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('finance.employee_dimensions_info.modals.set_assignments.buttons.cancel')}
          </Button>
          <Button disabled={!allowSubmit} onClick={onSave}>
            {i18n.t('finance.employee_dimensions_info.modals.set_assignments.buttons.save')}
          </Button>
        </>
      }
    >
      <Box flexDirection="column" gap="s40" padding="s24">
        {assignments.map((d) =>
          d.type == 'single-value' ? (
            <Box gap="s16" key={d.id}>
              <Box>
                <Text.Header2 color="grey1000">{d.name}</Text.Header2>
                <Text.Normal color="grey800">
                  {i18n.t(
                    'finance.employee_dimensions_info.modals.set_assignments.single_value_description'
                  )}
                </Text.Normal>
              </Box>
              <DimensionValuePicker
                withSelectStyle
                options={d.options}
                onChange={(value) => onChangeSingle(d.id, value, d.membershipId)}
                value={d.assignmentValue}
                placeholder={`-- ${i18n.t('finance.employee_dimensions_info.not_assigned')} --`}
              />
            </Box>
          ) : (
            <Box gap="s16" key={d.id}>
              <Box>
                <Text.Header2 color="grey1000">{d.name}</Text.Header2>
                <Text.Normal color="grey800">
                  {i18n.t(
                    'finance.employee_dimensions_info.modals.set_assignments.multiple_value_description'
                  )}
                </Text.Normal>
              </Box>
              <DimensionMultipleValuePicker
                values={d.assignments}
                options={d.options}
                legalEntityId={props.legalEntityId}
                onChange={(values) => onChangeMultiple(d.id, values)}
              />
            </Box>
          )
        )}
      </Box>
    </Sidepanel>
  )
}

export default SetAssignmentsPanel
